// Toast status includes 'warning' to match Chakra's UseToastOptions
// Note: AlertStatus uses 'warn' but Chakra toast uses 'warning'
export type ToastStatus = 'success' | 'info' | 'error' | 'warning';

export type ToastSemanticColors = {
	text: string;
	icon: string;
	closeBg: string;
	closeBgHover: string;
	closeBgActive: string;
};

export const toastSemanticColors: Record<ToastStatus, ToastSemanticColors> = {
	info: { text: 'info.text', icon: 'info.icon', closeBg: 'info.closeBg', closeBgHover: 'info.closeBgHover', closeBgActive: 'info.closeBgActive' },
	success: {
		text: 'success.text',
		icon: 'success.icon',
		closeBg: 'success.closeBg',
		closeBgHover: 'success.closeBgHover',
		closeBgActive: 'success.closeBgActive',
	},
	error: { text: 'error.text', icon: 'error.icon', closeBg: 'error.closeBg', closeBgHover: 'error.closeBgHover', closeBgActive: 'error.closeBgActive' },
	warning: {
		text: 'warning.text',
		icon: 'warning.icon',
		closeBg: 'warning.closeBg',
		closeBgHover: 'warning.closeBgHover',
		closeBgActive: 'warning.closeBgActive',
	},
};
